<template>
  <div id="viewMobile">
    <div class="main_bg">
      <!-- KV -->
      <div class="banner">
        <img :src="workspace.imgurlMobile" class="bannerBg" />
      </div>
      <!-- ID.4 X -->
      <div class="banner">
        <img :src="workspace1.imgurlMobile" class="bannerBg" />
        <div class="main2-content">
          <div class="detail-right">
            <h2 class="detail-title">{{ workspace1.title }}</h2>
            <div class="detail-content">
              {{ workspace1.subtitle }}
            </div>
          </div>
        </div>
      </div>

      <!-- 车型素材 -->
      <div class="banner">
        <img :src="workspace2.imgurlMobile" class="bannerBg" />
        <div class="main2-content">
          <div class="title">车型素材</div>
          <div class="detail-all">
            <div
              style="
                display: flex;
                justify-content: space-between;
                flex-direction: column-reverse;
              "
            >
              <div class="flex-chexing">
                <div class="layout-flex-chexing">
                  <div class="layout-flex-item" @click="handleList('waiguan')">
                    <img class="item-img" :src="workspace2.wurlMobile" />
                    <div class="item-model" v-show="listKeyFn('waiguan')"></div>
                    <div class="item-model-title">外观</div>
                  </div>
                  <div class="layout-flex-item" @click="handleList('neishi')">
                    <img class="item-img" :src="workspace2.nurlMobile" />
                    <div class="item-model" v-show="listKeyFn('neishi')"></div>
                    <div class="item-model-title">内饰</div>
                  </div>
                  <div class="layout-flex-item" @click="handleList('qita')">
                    <img class="item-img" :src="workspace2.qurlMobile" />
                    <div class="item-model" v-show="listKeyFn('qita')"></div>
                    <div class="item-model-title">其他</div>
                  </div>
                  <div class="layout-flex-item" @click="handleList('shipin')">
                    <img class="item-img" :src="workspace2.surlMobile" />
                    <div class="item-model" v-show="listKeyFn('shipin')"></div>
                    <div class="item-model-title">视频</div>
                  </div>
                </div>
              </div>
              <div class="carousel-chexing" :key="listKey">
                <el-carousel
                  indicator-position="none"
                  arrow="always"
                  style="width: 100%"
                >
                  <el-carousel-item
                    v-for="(item, index) in list"
                    :key="index"
                    @click.native="handleImg(item, index)"
                  >
                    <img class="carousel-item-img" :src="item" />
                    <img
                      class="videoPlay"
                      v-show="!listKeyFn('shipin')"
                      src="../../assets/id6/imgs/btn-video@2x.png"
                    />
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 交付 -->
      <div class="banner">
        <el-carousel arrow="never" style="width: 100%" :height="autoHeight">
          <el-carousel-item
            v-for="(item, index) in workspace3.list"
            :key="index"
          >
            <img :src="item.imgurlMobile" class="bannerBg" />
            <div class="main2-content">
              <div class="detail-left">
                <h2 class="detail-title">{{ item.title }}</h2>
                <h2 class="detail-title">{{ item.title1 }}</h2>
                <div class="detail-content">
                  {{ item.subtitle }}
                </div>
                <div class="detail-btn" @click="handleDetail(item.url)">
                  查看详情
                </div>
              </div>
            </div>
          </el-carousel-item></el-carousel
        >
      </div>
      <!-- 大咖点评 -->
      <div class="banner daka">
        <div
          class="title"
          style="position: absolute; z-index: 999; width: 100vw"
        >
          大咖点评
        </div>
        <el-carousel
          indicator-position="none"
          arrow="always"
          :autoplay="false"
          style="width: 100%"
          :height="autoHeight"
        >
          <el-carousel-item
            v-for="(item, index) in workspace4.list"
            :key="index"
          >
            <img :src="item.imgurlMobile" class="bannerBg" />
            <div class="main2-content">
              <div class="detail-right" style="top: 91px">
                <h2 class="detail-title">
                  <img :src="item.titleMobile" style="width: 70px" />
                </h2>
                <div class="detail-content">
                  {{ item.subtitle }}
                </div>
                <div class="detail-btn" @click="handleDetail(item.url)">
                  查看原文
                </div>
              </div>
            </div>
          </el-carousel-item></el-carousel
        >
      </div>
      <!-- 媒体试驾 -->
      <div class="banner meiti">
        <img :src="workspace5.imgurlMobile" class="bannerBg" />
        <div class="main2-content">
          <div class="title">媒体试驾</div>
          <div class="detail-all" style="top: 55%">
            <el-carousel
              indicator-position="none"
              arrow="always"
              :autoplay="false"
              style="width: 100%"
            >
              <el-carousel-item
                v-for="(item, index) in workspace5.shipin"
                :key="item"
              >
                <div class="layout-flex">
                  <div
                    class="layout-flex-item"
                    @click="handleImg2(item, index)"
                  >
                    <img class="carousel-item-img" :src="item" />
                    <img
                      class="videoPlay"
                      src="../../assets/id6/imgs/btn-video@2x.png"
                    />
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible">
      <el-carousel
        indicator-position="none"
        arrow="always"
        :autoplay="false"
        style="width: 100%"
        height="226px"
        :initial-index="dialogIndex"
      >
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <img :src="item" style="width: 100%" />
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" v-if="dialogVisible2">
      <div style="height: 226px">
        <contentVideo2 :url="dialogVideo"></contentVideo2>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import contentVideo from "./components/contentVideoMobile.vue";
import contentVideo2 from "./components/contentVideoMobile2.vue";
import config from "./config";
export default {
  components: {
    contentVideo,
    contentVideo2,
  },
  data() {
    return {
      ...config,
      // 图片
      dialogVisible: false,
      // 视频
      dialogVisible2: false,
      dialogIndex: 0,
      dialogImg: "",
      dialogVideo: "",
      // 控制弹框视频
      dialogKey: "",
      listKey: "waiguan",
      list: config.workspace2.waiguan,
    };
  },
  computed: {
    autoHeight() {
      // 横满屏轮播图时，根据宽高比例动态计算轮播图所需高度
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      return (_w * 1030) / 750 + "px";
    },
  },
  mounted() {},
  methods: {
    listKeyFn(val) {
      let bool = this.listKey === val;
      return !bool;
    },
    handleList(val) {
      this.listKey = val;
      this.list = this.workspace2[val];
    },
    // 车型素材-图片
    handleImg(val, index) {
      if (this.listKey === "shipin") {
        this.handleVideo(val, index);
      } else {
        this.dialogVisible = true;
        this.dialogIndex = index;
      }
    },
    // 车型素材-视频
    handleVideo(val, index) {
      this.dialogVisible2 = true;
      this.dialogVideo = this.workspace2.videourl[index];
    },
    // 媒体试驾
    handleImg2(val, index) {
      this.dialogVisible2 = true;
      this.dialogVideo = this.workspace5.videourl[index];
    },
    // 现场直击
    handleImg3(val, index) {
      this.dialogVisible = true;
    },
    handleDetail(url) {
      window.open(url, "_self");
    },
  },
};
</script>

<style lang="less" scoped>
h2 {
  margin-top: 0;
  margin-bottom: 10px;
}
/deep/.el-carousel__arrow {
  background-color: #000000;
  opacity: 0.6;
}
/deep/.el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

// 弹框
/deep/.el-dialog {
  background: transparent;
  box-shadow: none;
  width: 325px;
  height: 256px;
  .el-dialog__body {
    padding: 0px;
  }
  .el-dialog__headerbtn {
    top: 0px;
    right: 0px;
  }
  .el-dialog__close {
    color: #fff;
  }
}

#viewMobile {
  width: 100%;
  min-width: 375px;
  margin: 0px auto;
  font-size: 14px;
}

//底纹
.main_bg {
  width: 100%;
  min-width: 375px;
}

//背景图
.banner {
  position: relative;
  .bannerBg {
    width: 100%;
    display: block;
  }
}

// 布局
.main2-content {
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  width: 325px;
  transform: translate(-50%, 0px);
}

// 标题
.title {
  text-align: center;
  margin-top: 40px;
  font-size: 30px;
  font-weight: 400;
  color: #ffffff;
}

// 布局全
.detail-all {
  position: absolute;
  width: 100%;
  color: #fff;
  z-index: 1;
  left: 0%;
  top: 50%;
  transform: translate(0%, -50%);
}
// 布局左
.detail-left {
  position: absolute;
  color: #fff;
  z-index: 1;
  left: 0;
  top: 62px;
  font-size: 12px;
}
// 布局右
.detail-right {
  position: absolute;
  color: #fff;
  z-index: 1;
  right: 0;
  top: 62px;
  font-size: 12px;
}

// 车型左边图
.flex-chexing {
  width: 100%;
  .layout-flex-chexing {
    display: flex;
    justify-content: space-between;
    align-content: space-between;
    flex-wrap: wrap;
    height: 55px;
    margin-top: 20px;
    .layout-flex-item {
      width: 75px;
      height: 55px;
      position: relative;
      cursor: pointer;
      .item-img {
        width: 100%;
        height: 100%;
      }
      .item-model {
        position: absolute;
        background: #000000;
        opacity: 0.6;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      .item-model-title {
        padding: 0px 10px;
        border-top: 1px solid;
        border-bottom: 1px solid;
        position: absolute;
        color: #ffffff;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 12px;
        width: 24px;
      }
    }
  }
}

// 车型右边图
.carousel-chexing {
  width: 100%;
  /deep/.el-carousel__container {
    height: 226px;
  }
  .carousel-item-img {
    width: 100%;
    height: 226px;
  }
}

// 大咖点评
.daka {
  /deep/.el-carousel__arrow--left {
    top: 94%;
    left: 30%;
  }
  /deep/.el-carousel__arrow--right {
    top: 94%;
    right: 30%;
  }
}

// 媒体试驾轮播图
.meiti {
  /deep/.el-carousel__container {
    height: 313px;
  }
  .layout-flex {
    display: flex;
    justify-content: space-between;
    .layout-flex-item {
      width: 100%;
      height: 313px;
      position: relative;
    }
    .carousel-item-img {
      width: 100%;
      height: 313px;
    }
  }
}

.videoPlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
}

// 详情标题
.detail-title {
}
// 详情内容
.detail-content {
  line-height: 16px;
}
// 详情按钮
.detail-btn {
  display: inline-block;
  border: 1px solid #f6f6f6;
  padding: 2px 5px;
  margin-top: 10px;
  cursor: pointer;
}
</style>
